import { StyleSheet, css } from 'aphrodite'
import type React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../contexts/UserContext'
import CompanyLogoUpload from '../CompanyLogoUpload'

const Topbar: React.FC = () => {
  const { user, logout } = useUser()
  const navigate = useNavigate()
  const [currentLogoUrl, setCurrentLogoUrl] = useState<
    string | null | undefined
  >(undefined)

  const handleLogoUpdate = (logoUrl: string | null) => {
    console.log('Topbar handleLogoUpdate called with:', logoUrl)
    setCurrentLogoUrl(logoUrl)
  }

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className={css(styles.topbar)}>
      <div className={css(styles.logoContainer)}>
        <CompanyLogoUpload
          currentLogoUrl={currentLogoUrl}
          onLogoUpdate={handleLogoUpdate}
          size="small"
          showRemoveButton={false}
          iconOnly={true}
        />
      </div>
      <div className={css(styles.rightSection)}>
        <button
          onClick={handleLogout}
          className={css(styles.logoutButton)}
          title="Logout"
        >
          <i className="fa-solid fa-sign-out-alt" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  )
}

const styles = StyleSheet.create({
  topbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 64,
    background: '#1F2A37', // Use your sidebar's background color
    padding: '0 32px',
    width: '100%',
    boxSizing: 'border-box',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    '@media (max-width: 900px)': {
      display: 'none', // Hide on mobile/tablet
    },
  },
  logoContainer: {
    marginLeft: -20,
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
  },
  logoutButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    background: 'none',
    border: 'none',
    color: '#9CA3AF',
    cursor: 'pointer',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    ':hover': {
      color: '#fff',
      backgroundColor: '#374151',
    },
  },
})

export default Topbar
